import styled from "styled-components";

import {
	COLOR_TEXT_PRIMARY_B2C,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	COLOR_WHITE,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	padding: 100px 0px 50px 0px;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 50px 0px 0px 0px;
		text-align: center;
	}
`;

export const Title = styled.h1`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 28px;
	line-height: 33px;
	text-align: center;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin: 0px;
`;

export const TabList = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 50px;
	padding: 20px;
	text-align: center;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: none;
	}
`;

export const SelectTabList = styled.div`
	margin: 24px;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: block;
	}
	display: none;
`;

export const TabItem = styled.span`
	padding: 10px;
	font-weight: ${FONT_WT_LIGHT};
	font-size: 18px;
	line-height: 26px;
	cursor: pointer;
	color: #48485e;
	border-radius: 3px;
	&:not(:last-child) {
		margin-right: 8px;
	}
	background-color: ${(props) => props.isActive && "#E5E5E5"};
`;

export const ReportContainer = styled.div`
	display: flex;
	justify-content: center;
	height: 100%;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		flex-direction: column;
	}
`;

export const Left = styled.div`
	width: 53%;
	padding: 30px;
	height: 100%;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 100%;
	}
`;

export const Right = styled.div`
	width: 47%;
	padding: 30px;
	height: 100%;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 100%;
		padding: 0px;
	}
`;
export const DownloadReportContainer = styled.div`
	background-color: ${(p) => (p.bg ? p.bg : "var(--primary-forest-600)")};
	height: 770px;
	max-width: 524px;

	margin-top: 45px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 60px 10px 60px 10px;

	.column-flex {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 286px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.column-flex {
			max-width: 300px;
		}
		max-width: unset;
		margin-top: 0px;
	}
	form {
		width: 100%;
	}

	.success-message {
		color: ${(p) => (p.font ? p.font : COLOR_WHITE)};
		font-weight: ${FONT_WT_LIGHT};
		font-size: 16px;
		line-height: 26px;
		margin-top: 90px;
		text-align: center;
		height: 0px;
	}
`;

export const Report = styled.div`
	max-width: 624px;
	margin-left: auto;
	margin-right: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const ReportTitle = styled.h2`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 28px;
	line-height: 33px;

	color: #48485e;
`;
export const ReportDescription = styled.p`
	font-weight: ${FONT_WT_LIGHT};
	font-size: 18px;
	line-height: 26px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;

export const Subtitle = styled.h3`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 20px;
	line-height: 23px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;
export const Compensation = styled.div`
	display: flex;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.salary {
		font-weight: ${FONT_WT_MEDIUM};
		font-size: 36px;
		line-height: 42px;

		color: ${COLOR_TEXT_PRIMARY_B2C};
	}

	.salary-info {
		font-weight: ${FONT_WT_LIGHT};
		font-size: 18px;
		line-height: 26px;
		margin-top: 10px;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
`;

export const CompensationItem = styled.div`
	width: 50%;
	height: 130px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	&:not(:last-child) {
		margin-right: 16px;
	}
	background: #f4f2f2;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 100%;
		&:not(:last-child) {
			margin-right: 0px;
		}

		&:last-child {
			margin-top: 20px;
		}
	}
`;

export const SectionContainer = styled.div`
	margin: 20px 0px 20px 0px;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin: 10px 0px 10px 0px;
	}
`;

export const Image = styled.div`
	.graph {
		width: 100%;
	}

	.downloadReport {
		width: 289px;
		margin-top: 30px;
		@media only screen and (max-width: ${MOBILE_L_BP}px) {
			width: 244px;
		}
	}
`;

export const DownloadReportTitle = styled.h3`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 24px;
	line-height: 28px;
	text-align: center;
	width: 100%;
	color: ${(p) => (p.font ? p.font : COLOR_TEXT_PRIMARY_B2C)};
	margin: 0px;
`;

export const InputContainer = styled.div`
	margin-top: 30px;
	width: 100%;
`;

export const DownloadButtonContainer = styled.div`
	margin-top: 15px;
	width: 100%;
	button {
		width: 100%;
	}
`;
